import { Platform } from "react-native"

export const APP_STORE_URL =
  "https://apps.apple.com/us/app/backflip-real-estate-investing/id1617572041"

export const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.dobackflip.backflip"

/** Store listing for the current platform. Falls back to the App Store on web. */
export const getAppStoreListingUrl = (): string =>
  Platform.select({
    android: PLAY_STORE_URL,
    default: APP_STORE_URL,
  })
